/* tslint:disable */
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { DataContextService } from './datacontext.service';
import { UserService } from './APIs/Users/userservice';
import { HttpClient } from '@angular/common/http';
import { UserSettingsService } from './user-settings.service';
import { AuthService } from '../auth.service';
import { OAuthService } from 'angular-oauth2-oidc';

// import { OAuthService } from 'angular-oauth2-oidc';


@Injectable({
  providedIn: 'root',
})
export class StartupService {
  constructor(
    private http: HttpClient,
    private userSettingsService: UserSettingsService,
    private injector: Injector,
    private hotelingDataContextService: DataContextService,
    private _userService: UserService,
    private authService:AuthService,
    private oAuthService:OAuthService
  ) {}

  getHotelingToken() {
   const msalService = this.injector.get(MsalService);
    const hotelingClientIDScope =
      this.userSettingsService.appSettings.HotelingCloudClientId + this.userSettingsService.appSettings.ConciergeScope;

    const hotelingCloudApiReq = {
      scopes: [hotelingClientIDScope],
    };
    return msalService.acquireTokenSilent(hotelingCloudApiReq);
  }

  getUserDetails(hotelingCloudToken: any) {
    const router = this.injector.get(Router);
    const msalService = this.injector.get(MsalService);

    return msalService
      .acquireTokenSilent({
        scopes: ['user.read'],
        account: msalService.instance.getAllAccounts()[0],
      }).toPromise()
      .then((res) => {
        window['hotelingDataToken'] = hotelingCloudToken;
        let emailSuffix = this.userSettingsService.appSettings.EmailSuffix;
        let alias = msalService.instance.getAllAccounts()[0].username.concat(emailSuffix);

        return this._userService
          .getUsersByEmail([alias])
          .toPromise()
          .then((r:any) => {
            if (r && r.length > 0 && r[0].user != null) {
              //need to remove
              let userObj = r[0].user;
              DataContextService.UserData = userObj;
              let isConciergeUser: boolean = JSON.parse(userObj.hasConciergeRights);
              if (!isConciergeUser) {
                router.navigate(['/AccessDenied']);
              }
            } else {
              router.navigate(['/AccessDenied']);
            }
          });
      });
  }

//   async authorizeUser() {
//    const msalService = this.injector.get(MsalService);
//    await msalService.instance.handleRedirectPromise();
//   const accounts = msalService.instance.getAllAccounts();
// if (accounts.length === 0) {
//     // No user signed in
//     msalService.instance.loginRedirect();
//         } else {
//           const account = msalService.instance.getAllAccounts();
//           if(!msalService.instance.getActiveAccount())
//           {
//             msalService.instance.setActiveAccount(account[0]);
//           }
//           if (msalService.instance.getActiveAccount()) {

//             return this.getHotelingToken().toPromise()
//               .then((res) => {
//                 localStorage.setItem('msal.hotelingTokenExpiry', this.getTokenExpired(res.accessToken));
//                 return this.getUserDetails(res.accessToken);
//               })
//               .catch((err) => {
//                 return Promise.reject(err);
//               });
//           } else {
//             return Promise.reject('User not logged in');
//           }
//         }
//       }

async authorizeUser() {
   await this.authService.init().then(()=>{
    const router = this.injector.get(Router);
    var claims = this.oAuthService.getIdentityClaims();

    console.log('claims', claims);

    let alias = 'antennyson@hermitage123.onmicrosoft.com'; //claims['email'];

    return this._userService
      .getUsersByEmail([alias])
      .toPromise()
      .then((r: any) => {
        if (r && r.length > 0 && r[0].user != null) {
          //need to remove
          let userObj = r[0].user;
          DataContextService.UserData = userObj;
          let isConciergeUser: boolean = JSON.parse(userObj.hasConciergeRights);
          if (!isConciergeUser) {
            router.navigate(['/AccessDenied']);
          }
        } else {
          router.navigate(['/AccessDenied']);
        }
      })
  })
  }


  graphApi() {
    const msalService = this.injector.get(MsalService);
    if (msalService.instance.getAllAccounts()[0]) {
      const graphApiReq = {
        scopes: ['user.read'],
      };
      return msalService.acquireTokenSilent(graphApiReq).toPromise().then((graphToken) => {
        localStorage.setItem('msal.graphApiAccessToken', graphToken.accessToken);
        localStorage.setItem('msal.graphApiTokenExpiry', this.getTokenExpired(graphToken.accessToken));
      });
    } else {
      return Promise.reject('User not logged in');
    }
  }

  getTokenExpired(token: string) {
    return JSON.parse(atob(token.split('.')[1])).exp;
  }

  loginRedirect() {
    const msalService = this.injector.get(MsalService);
    msalService.loginRedirect();
  }
}
